/**
 * @file Automatically generated by barrelsby.
 */

export * from './shared.module';
export * from './components/index';
export * from './pipes/index';
